import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Reassign Candidate|Exams|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPToolsReassignCandidateExams';
export type SPToolsReassignCandidateExamsLocNames =
	| `${LocNameStart}LabelExam`
	| `${LocNameStart}LabelRegistrationNumber`
	| `${LocNameStart}LabelDate`
	| `${LocNameStart}LabelGrade`;

export const spToolsReassignCandidateExamsLocs: LocDefs<SPToolsReassignCandidateExamsLocNames> = {
	SPToolsReassignCandidateExamsLabelExam: {
		defaultValue: 'Exam',
		description: 'Label for the Exam column',
		displayPath: `${pathStart}Exam`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.ExamName',
		...sharedProperties,
	},
	SPToolsReassignCandidateExamsLabelRegistrationNumber: {
		defaultValue: 'Registration Number',
		description: 'Label for the Registration Number column',
		displayPath: `${pathStart}Registration Number`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.ExamRegNumber',
		...sharedProperties,
	},
	SPToolsReassignCandidateExamsLabelDate: {
		defaultValue: 'Date',
		description: 'Label for the Date column',
		displayPath: `${pathStart}Date`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.ExamDate',
		...sharedProperties,
	},
	SPToolsReassignCandidateExamsLabelGrade: {
		defaultValue: 'Grade',
		description: 'Label for the Grade column',
		displayPath: `${pathStart}Grade`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.ExamGrade',
		...sharedProperties,
	},
};

export type SPToolsReassignCandidateExamsLocType = LocMap<SPToolsReassignCandidateExamsLocNames>;
